import { WidgetsSplitsMain } from '@/widgets/splits';

export const PagesSplitsMain = () => <WidgetsSplitsMain />;
